// INSPECTIONS ###################################################################

(function() {
    if (document.querySelector('.inspections__line')) {
        let resizeTimeout;
    
        function updateLinePosition() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                var line = document.querySelector('.inspections__line');
                line.classList.add('deco-line--active');
        
                var imgwrap = document.querySelector('.inspections__imgwrap');
                var imgwrapRect = imgwrap.getBoundingClientRect();
                var imgwrapHeight = imgwrapRect.height;
        
                var infobox = document.querySelector('.inspections__infobox');
                var infoboxRect = infobox.getBoundingClientRect();
                var infoboxHeight = infoboxRect.height;
        
                var width = window.innerWidth;
        
                requestAnimationFrame(() => {
                    if (width >= 1280) {
                        var heightDifference = imgwrapHeight - infoboxHeight;
                        line.style.top = (heightDifference + 1) + 'px';
                        line.style.bottom = ''; // Usuń bottom
                    } else {
                        var panel = document.querySelector('.inspections__panel');
                        var panelRect = panel.getBoundingClientRect();
                        var panelHeight = panelRect.height;
        
                        var infoboxStyle = window.getComputedStyle(infobox);
                        var infoboxPaddingTop = parseFloat(infoboxStyle.paddingTop);
        
                        var heading = document.querySelector('.inspections__heading');
                        var headingRect = heading.getBoundingClientRect();
                        var headingHeight = headingRect.height;
        
                        var btnbox = document.querySelector('.inspections__btnbox');
                        var btnboxStyle = window.getComputedStyle(btnbox);
                        var btnboxMarginTop = parseFloat(btnboxStyle.marginTop);
        
                        var btnboxRect = btnbox.getBoundingClientRect();
                        var btnboxHeight = btnboxRect.height;
                        var btnboxHalfHeight = btnboxHeight / 2;
        
                        var topValue = panelHeight - infoboxHeight
                                        + infoboxPaddingTop
                                        + headingHeight
                                        + btnboxMarginTop
                                        + btnboxHalfHeight
                                        - 1;
        
                        line.style.top = topValue + 'px';
                        line.style.bottom = ''; // Usuń bottom
                    }
                });
            }, 150); // Czas debounce w milisekundach
        }
        
        window.addEventListener('load', updateLinePosition);
        window.addEventListener('resize', updateLinePosition);
    }
})();

// CTABOXES (MULTIPLE INSTANTIONS) ###################################################################

(function() {
    // Sprawdź, czy istnieje jakikolwiek element ctabox na stronie
    if (document.querySelector('.ctabox')) {
        let resizeTimeout;

        function updateLinePositions() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Pobierz wszystkie elementy ctabox
                const ctaboxes = document.querySelectorAll('.ctabox');

                ctaboxes.forEach(ctabox => {
                    // Znajdź linię, która jest następnym elementem względem ctabox
                    const line = ctabox.nextElementSibling;
                    if (!line || !line.classList.contains('ctabox-line')) return; // Pomijaj, jeśli brak odpowiedniego elementu

                    line.classList.add('deco-line--active');

                    // Znajdź przycisk w bieżącym ctabox i oblicz jego połowę wysokości
                    const button = ctabox.querySelector('.ctabox__btn1');
                    if (!button) return; // Pomijaj, jeśli brak przycisku
                    const buttonRect = button.getBoundingClientRect();
                    const buttonHeight = buttonRect.height / 2; // Podziel wysokość przez 2

                    // Znajdź element tekstowy i pobierz padding-bottom
                    const textPart = ctabox.querySelector('.ctabox__part--text');
                    if (!textPart) return; // Pomijaj, jeśli brak tekstu
                    const textPartStyle = window.getComputedStyle(textPart);
                    const paddingBottom = parseFloat(textPartStyle.paddingBottom);

                    // Oblicz całkowitą wartość bottom
                    const totalBottom = buttonHeight + paddingBottom;

                    // Ustaw styl bottom i usuń top
                    requestAnimationFrame(() => {
                        line.style.bottom = totalBottom + 'px';
                        line.style.top = ''; // Usuń top
                    });
                });
            }, 150); // Czas debounce w milisekundach
        }

        // Dodaj nasłuchiwanie na załadowanie strony i zmianę rozmiaru okna
        window.addEventListener('load', updateLinePositions);
        window.addEventListener('resize', updateLinePositions);
    }
})();

// CASE-STUDIES ###################################################################

(function() {
    if (document.querySelector('.case-studies')) {
        let resizeTimeout;

        function updateLinePosition() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                var line = document.querySelector('.case-studies__line');
                line.classList.add('deco-line--active');
        
                var textbox = document.querySelector('.case-studies__textbox');
                var textboxStyle = window.getComputedStyle(textbox);
                var textboxPaddingBottom = parseFloat(textboxStyle.paddingBottom);

                var btnbox = document.querySelector('.case-studies__pane-btnbox');
                var btnboxRect = btnbox.getBoundingClientRect();
                var btnboxHalfHeight = btnboxRect.height / 2;
        
                var width = window.innerWidth;
        
                requestAnimationFrame(() => {
                    var bottomValue;
                    
                    if (width >= 992) {
                        // Dla rozdzielczości 992px i więcej
                        bottomValue = textboxPaddingBottom + 41 + btnboxHalfHeight;
                    } else {
                        // Dla rozdzielczości poniżej 992px
                        bottomValue = textboxPaddingBottom + 1 + btnboxHalfHeight;
                    }

                    line.style.bottom = bottomValue + 'px';
                    line.style.top = ''; // Usuń top niezależnie od rozdzielczości
                });
            }, 150); // Czas debounce w milisekundach
        }
        
        window.addEventListener('load', updateLinePosition);
        window.addEventListener('resize', updateLinePosition);
    }
})();


// LATEST ###################################################################

(function() {
    if (document.querySelector('.latest')) {
        let resizeTimeout;

        function updateLinePosition() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                var line = document.querySelector('.latest__line');
                line.classList.add('deco-line--active');
        
                var heading = document.querySelector('.latest__heading');
                var headingStyle = window.getComputedStyle(heading);
                var headingHeight = heading.offsetHeight;
                var headingMarginBottom = parseFloat(headingStyle.marginBottom);

                var firstTopElement = document.querySelector('.blog-panel__top');
                var firstTopElementHeight = firstTopElement.offsetHeight;
        
                // Oblicz wartość top
                var topValue = headingHeight + headingMarginBottom + firstTopElementHeight;

                requestAnimationFrame(() => {
                    line.style.top = topValue + 1 + 'px';
                    line.style.bottom = ''; // Usuń bottom, ponieważ jest obliczane tylko top
                });
            }, 150); // Czas debounce w milisekundach
        }
        
        window.addEventListener('load', updateLinePosition);
        window.addEventListener('resize', updateLinePosition);
    }
})();


// JOBS ###################################################################

(function() {
    if (document.querySelector('.jobs__card')) {
        let resizeTimeout;
    
        function updateLinePosition() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Znajdź ostatni element jobs__card
                const lastJobCard = document.querySelector('.jobs__card:last-of-type');
    
                if (lastJobCard) {
                    const lastJobCardHeight = lastJobCard.getBoundingClientRect().height / 2; // Wysokość podzielona na 2
    
                    // Znajdź element jobs__line
                    const line = document.querySelector('.jobs__line');
    
                    if (line) {
                        line.classList.add('deco-line--active');
    
                        requestAnimationFrame(() => {
                            line.style.bottom = lastJobCardHeight + 'px';
                            line.style.top = ''; // Usuń top na wypadek wcześniejszych zmian
                        });
                    }
                }
            }, 150); // Czas debounce w milisekundach
        }
    
        window.addEventListener('load', updateLinePosition);
        window.addEventListener('resize', updateLinePosition);
    }    
})();

// MAP ###################################################################

(function() {
    // Sprawdź, czy istnieje element z klasą "map"
    if (document.querySelector('.map')) {
        let resizeTimeout;

        function updateLinePosition() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Znajdź element map__detailsbox
                const detailsBox = document.querySelector('.map__detailsbox');
                const btnBox = document.querySelector('.map__btnbox');

                if (detailsBox && btnBox) {
                    // Pobierz wartości bottom, padding-bottom i połowę wysokości map__btnbox
                    const detailsBoxBottom = parseFloat(getComputedStyle(detailsBox).bottom) || 0;
                    const detailsBoxPaddingBottom = parseFloat(getComputedStyle(detailsBox).paddingBottom) || 0;
                    const btnBoxHeightHalf = btnBox.getBoundingClientRect().height / 2;

                    // Oblicz sumę wartości
                    const bottomValue = detailsBoxBottom + detailsBoxPaddingBottom + btnBoxHeightHalf;

                    // Znajdź element map__line
                    const line = document.querySelector('.map__line');

                    if (line) {
                        line.classList.add('deco-line--active');

                        requestAnimationFrame(() => {
                            line.style.bottom = bottomValue + 'px';
                            line.style.top = ''; // Usuń top na wypadek wcześniejszych zmian
                        });
                    }
                }
            }, 150); // Czas debounce w milisekundach
        }

        window.addEventListener('load', updateLinePosition);
        window.addEventListener('resize', updateLinePosition);
    }
})();
